<template>
  <div class="app-service-modal-wrapper">
    <TariffChangeBookingModal
      :show.sync = showProp
      :content = modalContent
      :actions = "createActions(selectedOption)"
      :btn-already-clicked="btnAlreadyClicked"
      @click:activate="activate(selectedOption)"
      @click:deactivate="deactivate(selectedOption)"
    >
      <template v-for="slot in possibleChildSlotsFor('Modal', selectedOption.tariffoptionId)" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </TariffChangeBookingModal>
  </div>
</template>
<script>
import TariffChangeBookingModal from '@/components/process/generic/Tariff/generic/TariffChangeBookingModal.vue'
import slotProxy from '@/mixins/slotProxy'
import { mapActions } from 'vuex'

export default {
  name: 'ServiceModalWrapper',
  components: { TariffChangeBookingModal },
  data () {
    return {
      show: false,
      selectedOption: [],
      btnAlreadyClicked: false
    }
  },
  mixins: [
    slotProxy()
  ],
  computed: {
    modalContent: function () {
      return {
        title: this.selectedOption.tariffExtra?.name || '',
        detailBoxes: this.createDetails(this.selectedOption)
      }
    },
    showProp: {
      get: function () {
        return this.show
      },
      set: function () {
        this.show = false
        this.$emit('close')
      }
    }
  },
  methods: {
    ...mapActions('serviceOptions', [
      'saveSelectedOptions',
      'saveDeactivateOptions'
    ]),
    activate (option) {
      const me = this
      this.btnAlreadyClicked = true
      this.saveSelectedOptions({
        option: option
      }).then((response) => {
        if (response) {
          me.$emit('refresh')
        }
        this.show = false
        this.btnAlreadyClicked = false
      }, () => {
        this.show = false
        this.btnAlreadyClicked = false
      })
    },
    deactivate (option) {
      const me = this
      this.btnAlreadyClicked = true
      this.saveDeactivateOptions({
        option: option
      }).then((response) => {
        if (response) {
          me.$emit('refresh')
        }
        this.show = false
        this.btnAlreadyClicked = false
      }, () => {
        this.show = false
        this.btnAlreadyClicked = false
      })
    },
    showBookableServiceModal (option, optionList) {
      this.show = true
      this.selectedOption = optionList?.find(el => {
        return (el.tariffoptionId === option)
      })
    },
    createActions (option) {
      if (this.deactivatable(option)) {
        return [
          {
            type: 'deactivate',
            text: 'Option kündigen',
            disabled: this.btnAlreadyClicked
          }
        ]
      }
      if (this.activatable(option)) {
        return [
          {
            type: 'activate',
            text: 'Aktivieren',
            disabled: this.btnAlreadyClicked
          }
        ]
      }
      return null
    },
    activatable (option) {
      return !option.anonymousCallRejection
    },
    deactivatable (option) {
      return option.anonymousCallRejection
    },
    createDetails (option) {
      return option.tariffExtra?.volumes || []
    }
  }
}
</script>
